export function customSelect() {
    if (!$("form.checkout, .main-dashboard-holder").length) {
        if ($("select").length) {
            jcf.setOptions("Select", {
                wrapNative: false,
                flipDropToFit: false,
                fakeDropInBody: false,
                maxVisibleItems: 6,
            });

            jcf.replaceAll();
        }
    }
    if ($(".jcf-scrollable").length) {
        jcf.replaceAll();
    }

    $(window).on("resize", function () {
        if ($(".jcf-scrollable").length) {
            setTimeout(function () {
                jcf.destroyAll();
                jcf.replaceAll();
            }, 800);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js